import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import { AsyncProps } from 'chakra-react-select';
import React, { PropsWithoutRef } from 'react';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';
import FormLabelCustom from './FormLabel';
import InputMask from 'react-input-mask';

interface InputProps<T extends FieldValues = FieldValues>
  extends PropsWithoutRef<Omit<AsyncProps<any, any, any>, `onChange`>> {
  control: Control<T>;
  label: string;
  labelProps?: any;
  type: 'password' | 'text' | 'email' | 'number' | 'datetime-local' | 'tel';
  name: string;
  placeholder?: string;
  rules?: RegisterOptions<any>;
  onChange?: (e: string) => void;
}

function InputMaskDocument<T extends FieldValues = FieldValues>({
  control,
  label,
  rules,
  name,
  placeholder,
  type,
  labelProps = {},
  onChange: customOnChange,
  onBlur,
  ...props
}: InputProps<T>) {
  const CPF_MASK = '999.999.999-999';
  const CNPJ_MASK = '**.***.***/****-99';
  const FORMAT_CHARS = { '9': '[0-9]', '*': '[0-9A-Za-z]' };

  return (
    <Controller
      control={control}
      name={name as FieldPath<T>}
      rules={rules as RegisterOptions<T, FieldPath<T>>}
      render={({ field: { onChange, name, value }, fieldState: { invalid, error } }) => (
        <FormControl isInvalid={invalid}>
          <FormLabelCustom label={label} name={name} props={labelProps} />
          <InputMask
            mask={value?.length < 15 ? CPF_MASK : CNPJ_MASK}
            formatChars={FORMAT_CHARS}
            value={value}
            onBlur={onBlur}
            maskChar={null}
            onChange={(e) => {
              e.target.value = (e.target.value || '').toUpperCase();
              onChange(e);
              customOnChange && customOnChange(e);
            }}
          >
            {(inputProps) => (
              <Input
                bg="white"
                name={name}
                {...props}
                {...inputProps}
                size={'sm'}
                type={type}
                fontSize={'sm'}
                ms={{ base: '0px', md: '0px' }}
                placeholder={placeholder}
                required
              />
            )}
          </InputMask>

          <FormErrorMessage>{error?.message || 'Campo inválido'}</FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

export default InputMaskDocument;
